export default "__VITE_ASSET__3yy849b4__"